// 是否苹果手机或平板
export function isIphone() {
  const sUserAgent = navigator.userAgent.toLowerCase();
  const bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  const bIsIpadMac = sUserAgent.match(/mac os/i) == "mac os";
  const bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  return bIsIphoneOs || bIsIpad || bIsIpadMac;
}
/**
 * 生成指定范围随机数
 * @param {int} minNum 最小值
 * @param {int} maxNum 最大值
 */
export function randomNum(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10);
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
    default:
      return 0;
  }
}

export function addJs(src, callback) {
  if (existJs(src)) {
    if (callback) {
      callback();
    }
    return;
  }
  const script = document.createElement("script");
  script.setAttribute("type", "text/javascript");
  script.setAttribute("src", src);
  document.getElementsByTagName("body")[0].appendChild(script);
  script.onload = () => {
    if (callback) {
      callback();
    }
  };
}

export function existJs(src) {
  const script = document.getElementsByTagName("script");
  for (var i = script.length; i >= 0; i--) {
    if (
      script[i] &&
      script[i].getAttribute("src") != null &&
      script[i].getAttribute("src").indexOf(src) !== -1
    ) {
      return true;
    }
  }
  return false;
}

export function removeJs(src) {
  const script = document.getElementsByTagName("script");
  for (var i = script.length; i >= 0; i--) {
    if (
      script[i] &&
      script[i].getAttribute("src") != null &&
      script[i].getAttribute("src").indexOf(src) !== -1
    ) {
      script[i].parentNode.removeChild(script[i]);
    }
  }
}

/**
 * 判断是否为移动端
 */
export function isMobile() {
  if (
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true;
  } else {
    return false;
  }
}

export function dateFormat(date, fmt) {
  if (!date) return "";
  const thisDate = new Date(date.replace(/\-/g, "/"));
  var o = {
    "M+": thisDate.getMonth() + 1,
    "d+": thisDate.getDate(),
    "h+": thisDate.getHours(),
    "m+": thisDate.getMinutes(),
    "s+": thisDate.getSeconds(),
    "q+": Math.floor((thisDate.getMonth() + 3) / 3),
    S: thisDate.getMilliseconds(),
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (thisDate.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}

import axios from "axios";
/**
 * 校验弱密码
 * @param {String} password
 * @return {Boolean}
 */
export const checkWeakPassword = (password) => {
  return new Promise((resolve, reject) => {
    //   resolve(true) // 等弱密码确认上线后删除
    let flag = false;
    axios
      .get("https://myjs.beegoedu.com/static/weak_password_rules.json")
      .then((response) => {
        if (!response.data.includes(password)) flag = true;
        resolve(flag);
      })
      .catch((error) => {
        console.error("检查密码弱点时发生错误:", error);
        // 在遇到错误时，可以选择返回false或重新抛出错误
        reject(flag);
      });
  });
};

/**
 * @name 正则匹配密码 8-20位
 */
export const lingthPsw = (password) => {
  let validPwdLengthOnly = /^.{8,20}$/;
  return !validPwdLengthOnly.test(password);
};

/**
 * @name 判断字符串是否包含空白字符的正则表达式
 */
export const whitespacePsw = (password) => {
  return /\s/.test(password);
};

/**
 * @name 正则匹配密码 需包含大小写字母、数字和特殊字符三种
 */
export const includePsw = (password) => {
  const hasLower = /[a-z]/.test(password);
  const hasUpper = /[A-Z]/.test(password);
  const hasDigit = /[0-9]/.test(password);
  const hasSpecial = /[^a-zA-Z0-9]/.test(password); // 简单有效
  const typeCount = [hasLower, hasUpper, hasDigit, hasSpecial].filter(
    Boolean
  ).length;
  // 至少包含三种字符类型
  return typeCount < 3;
};

/**
 * @name 密码出现连续5位及以上相同字符正则表达式
 */
export const samePsw = (password) => {
  return /(.)\1{4,}/.test(password);
};

/**
 * @name 连续5位及以上递增/递减字符
 */
export const continuousPsw = (password) => {
  // 1. 匹配连续5位及以上同大小写字母/数字递增序列（拆分大小写确保匹配精准）
  const increaseReg =
    /abcde|bcdef|cdefg|defgh|efghi|fghij|ghijk|hijkl|ijklm|jklmn|klmno|lmnop|nopqr|opqrs|pqrst|qrstu|rstuv|stuvw|tuvwx|uvwxy|vwxyz|ABCDE|BCDEF|CDEFG|DEFGH|EFGHI|FGHIJ|GHIJK|HIJKL|IJKLM|JKLMN|KLMNO|LMNOP|MNOPQ|NOPQR|OPQRS|PQRST|QRSTU|RSTUV|STUVW|TUVWX|UVWXY|VWXYZ|01234|12345|23456|34567|45678|56789/;

  // 2. 匹配连续5位及以上同大小写字母/数字递减序列（拆分大小写确保匹配精准）
  const decreaseReg =
    /zyxwv|yxwvu|xwvut|wvuts|vutsr|utsrq|tsrqp|srqpo|rqpon|qponm|ponml|onmlk|nmlkj|mlkji|lkjih|kjihg|jihgf|ihgfe|hgfed|gfedc|fedcb|edcba|ZYXWV|YXWVU|XWVUT|WVUTS|VUTSR|UTSRQ|TSRQP|SRQPO|RQPON|QPONM|PONML|ONMLK|NMLKJ|MLKJI|LKJIH|KJIHG|JIHGF|IHGFE|HGFED|GFEDC|FEDCB|EDCBA|98765|87654|76543|65432|54321|43210/;

  // 违规判定：满足任意一条违规规则即返回true（校验不通过）
  return increaseReg.test(password) || decreaseReg.test(password);
};

/**
 * @name 使用统一的密码判断函数，避免重复代码
 */
export const validatePassword2 = (value) => {
  if (!value) {
    return { isValid: false, message: "请输入密码" };
  }
  if (lingthPsw(value)) {
    return { isValid: false, message: "请输入8-20位密码" };
  }
  if (whitespacePsw(value)) {
    return { isValid: false, message: "密码不允许包含空白字符,请重新输入" };
  }
  if (includePsw(value)) {
    return {
      isValid: false,
      message:
        "需包含大写字母、小写字母、数字及特殊字符中的至少三种，请重新设置",
    };
  }
  if (samePsw(value)) {
    return {
      isValid: false,
      message: "密码不允许出现连续5位及以上相同字符，请重新设置",
    };
  }
  if (continuousPsw(value)) {
    return {
      isValid: false,
      message: "密码不允许出现连续5位及以上递增/递减字符，请重新设置",
    };
  }
  return { isValid: true, message: "" };
};
